import { AlertTriangle, ChevronRight, Globe, History, ShieldCheck, User, UserRound } from "lucide-react";
import { Empty, Pill } from "../comptabilite/_shared";

export const ACTION_CLS = {
  create: "bg-emerald-50 text-emerald-700 border-emerald-200", update: "bg-sky-50 text-sky-700 border-sky-200", delete: "bg-rose-50 text-rose-700 border-rose-200",
  action: "bg-violet-50 text-violet-700 border-violet-200", login: "bg-slate-100 text-slate-700 border-slate-200", logout: "bg-slate-100 text-slate-700 border-slate-200",
  login_failed: "bg-amber-50 text-amber-800 border-amber-200",
};
export const ACTOR_ICON = { admin: ShieldCheck, portal: UserRound, public: Globe, system: History, anonymous: User };
export const ACTOR_LABEL = { admin: "Administrateur", portal: "Client du portail", public: "Lien public", system: "Système", anonymous: "Anonyme" };

export function fmtTs(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("fr-CA", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" });
}

export function Actor({ actor, onClick, testId }) {
  const Icon = ACTOR_ICON[actor?.type] || User;
  const cls = actor?.type === "admin" ? "text-emerald-700" : actor?.type === "portal" ? "text-sky-700" : "text-slate-500";
  return (
    <button onClick={onClick} className={`inline-flex items-center gap-1.5 text-xs font-medium hover:underline text-left ${cls}`} title={ACTOR_LABEL[actor?.type] || ""} data-testid={testId}>
      <Icon className="w-3.5 h-3.5 shrink-0" /> <span className="truncate max-w-[180px]">{actor?.label || "—"}</span>
    </button>
  );
}

export default function AuditTable({ items, onOpen, onFilterActor, onFilterModule }) {
  if (!items.length) return <div className="bg-white border rounded-xl"><Empty icon={History} text="Aucune action consignée pour ces critères." testId="audit-empty" /></div>;
  return (
    <div className="bg-white border rounded-xl overflow-x-auto" data-testid="audit-table-wrap">
      <table className="w-full text-xs" data-testid="audit-table">
        <thead className="bg-slate-50 text-slate-500 uppercase text-[10px] tracking-wider">
          <tr>
            <th className="text-left px-3 py-2 font-semibold">Date / heure</th>
            <th className="text-left px-3 py-2 font-semibold">Acteur</th>
            <th className="text-left px-3 py-2 font-semibold">Module</th>
            <th className="text-left px-3 py-2 font-semibold">Action</th>
            <th className="text-left px-3 py-2 font-semibold">Détail</th>
            <th className="text-left px-3 py-2 font-semibold">Statut</th>
            <th className="px-2 py-2"></th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {items.map((e) => (
            <tr key={e.id} className={`hover:bg-slate-50 cursor-pointer ${e.ok ? "" : "bg-rose-50/40"}`} onClick={() => onOpen(e)} data-testid={`audit-row-${e.id}`}>
              <td className="px-3 py-2 whitespace-nowrap tabular-nums text-slate-700" data-testid={`audit-ts-${e.id}`}>{fmtTs(e.ts)}</td>
              <td className="px-3 py-2" onClick={(ev) => ev.stopPropagation()}><Actor actor={e.actor} onClick={() => onFilterActor(e.actor)} testId={`audit-actor-${e.id}`} /></td>
              <td className="px-3 py-2 whitespace-nowrap" onClick={(ev) => ev.stopPropagation()}>
                <button onClick={() => onFilterModule(e.module)} className="text-slate-700 hover:underline" data-testid={`audit-module-${e.id}`}>{e.module}</button>
              </td>
              <td className="px-3 py-2 whitespace-nowrap"><Pill cls={ACTION_CLS[e.action] || ACTION_CLS.action} testId={`audit-action-${e.id}`}>{e.action_label}</Pill></td>
              <td className="px-3 py-2 text-slate-700 max-w-[360px]">
                <div className="truncate" title={e.summary} data-testid={`audit-summary-${e.id}`}>{e.summary || <span className="text-slate-400">{e.entity?.kind}</span>}</div>
                {e.entity?.master_label && <div className="text-[10px] text-slate-400 truncate">Dossier {e.entity.master_label}</div>}
                {e.error && <div className="text-[10px] text-rose-600 truncate flex items-center gap-1"><AlertTriangle className="w-3 h-3 shrink-0" /> {e.error}</div>}
              </td>
              <td className="px-3 py-2 whitespace-nowrap">
                {e.ok ? <Pill cls="bg-emerald-50 text-emerald-700 border-emerald-200" testId={`audit-status-${e.id}`}>OK</Pill> : <Pill cls="bg-rose-50 text-rose-700 border-rose-200" testId={`audit-status-${e.id}`}>Erreur {e.status}</Pill>}
              </td>
              <td className="px-2 py-2 text-slate-300"><ChevronRight className="w-4 h-4" /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
